var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4023 18C59.4023 18 58.8164 13.8633 57.0117 12.0469C54.7266 9.65625 52.1719 9.64453 51 9.50391C42.6094 8.89453 30.0117 8.89453 30.0117 8.89453H29.9883C29.9883 8.89453 17.3906 8.89453 9 9.50391C7.82813 9.64453 5.27344 9.65625 2.98828 12.0469C1.18359 13.8633 0.609375 18 0.609375 18C0.609375 18 0 22.8633 0 27.7148V32.2617C0 37.1133 0.597656 41.9766 0.597656 41.9766C0.597656 41.9766 1.18359 46.1133 2.97656 47.9297C5.26172 50.3203 8.26172 50.2383 9.59766 50.4961C14.4023 50.9531 30 51.0938 30 51.0938C30 51.0938 42.6094 51.0703 51 50.4727C52.1719 50.332 54.7266 50.3203 57.0117 47.9297C58.8164 46.1133 59.4023 41.9766 59.4023 41.9766C59.4023 41.9766 60 37.125 60 32.2617V27.7148C60 22.8633 59.4023 18 59.4023 18ZM23.8008 37.7812V20.918L40.0078 29.3789L23.8008 37.7812Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.9dc165b28691ca60114660e55e06f438.svg";
export { ForwardRef as ReactComponent };